/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Method_Card_TerminalInputs */

const en_my_payments_method_card_terminal = /** @type {(inputs: My_Payments_Method_Card_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`card at the desk`)
};

const pl_my_payments_method_card_terminal = /** @type {(inputs: My_Payments_Method_Card_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`karta na miejscu`)
};

/**
* | output |
* | --- |
* | "card at the desk" |
*
* @param {My_Payments_Method_Card_TerminalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_method_card_terminal = /** @type {((inputs?: My_Payments_Method_Card_TerminalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Method_Card_TerminalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_method_card_terminal(inputs)
	return en_my_payments_method_card_terminal(inputs)
});